import {
  GuideViewEventGeneratorParams,
  guideViewContextGenerator,
  viewEventGenerator,
} from './contextGenerators';

export const guideViewEventGenerator = ({
  viewUuid,
  date,
  title,
  programId,
  entityId,
  viewMode,
  areenaViewType,
  areenaGuideContextPredicate,
}: GuideViewEventGeneratorParams) => {
  const event = viewEventGenerator(viewUuid, 'entity', viewMode);
  const context = guideViewContextGenerator({
    date,
    label: title,
    programId,
    entityId,
    areenaViewType,
    areenaGuideContextPredicate,
  });

  return { event, context };
};
